var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 425,
    viewBox: "0 0 288 425",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 287.037,
    height: 425,
    fill: "#30B36B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15015_62277)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.7618,
    y: 410.238,
    width: 396.402,
    height: 256.701,
    transform: "rotate(-90 14.7618 410.238)",
    stroke: "white",
    strokeWidth: 1.74626
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.406 167.159C170.812 167.159 193.787 189.384 193.787 216.736C193.787 244.088 170.812 266.313 142.406 266.313C113.999 266.313 91.0245 244.088 91.0245 216.736C91.0245 189.384 113.999 167.159 142.406 167.159Z",
    stroke: "white",
    strokeWidth: 1.74626
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.8887,
    y1: 215.4,
    x2: 272.336,
    y2: 215.4,
    stroke: "white",
    strokeWidth: 1.74626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.9112,
    y: 410.238,
    width: 84.4487,
    height: 162.403,
    transform: "rotate(-90 61.9112 410.238)",
    stroke: "white",
    strokeWidth: 1.74626
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8359 326.14C106.685 314.758 123.275 307.284 142.082 307.284C160.888 307.284 177.479 314.758 187.327 326.14",
    stroke: "white",
    strokeWidth: 1.74626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.8512,
    y: 410.1,
    width: 46.1098,
    height: 104.776,
    transform: "rotate(-90 89.8512 410.1)",
    stroke: "white",
    strokeWidth: 1.74626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.313,
    y: 13.836,
    width: 81.5516,
    height: 162.403,
    transform: "rotate(90 224.313 13.836)",
    stroke: "white",
    strokeWidth: 1.74626
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.388 95.0781C179.539 106.077 162.949 113.3 144.142 113.3C125.336 113.3 108.745 106.077 98.8967 95.0781",
    stroke: "white",
    strokeWidth: 1.74626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.373,
    y: 13.9698,
    width: 44.5013,
    height: 104.776,
    transform: "rotate(90 196.373 13.9698)",
    stroke: "white",
    strokeWidth: 1.74626
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15015_62277",
    x: 12.1424,
    y: 12.0898,
    width: 261.94,
    height: 401.641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.873132
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.873132
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.756863 0 0 0 0 0.713726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15015_62277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15015_62277",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldIcon);
export default __webpack_public_path__ + "static/media/field-icon.e38a704459dbbfaa6f37d71fedf272bd.svg";
export { ForwardRef as ReactComponent };